import { Injectable } from '@angular/core';
import { ApplicationSettings } from 'lib-config';
import { LiveUpdateConnector } from '../models/live-update-connector.model';

@Injectable({
  providedIn: 'root'
})
export class LiveUpdateConnections {
  
  connectors: { [id: string] : LiveUpdateConnector } = {};

  constructor(private settings: ApplicationSettings) { }

  getConnector(endpoint: string) : LiveUpdateConnector  {
    //build connector 
    var connector = new LiveUpdateConnector(this.settings, endpoint);
    if(!this.connectors[connector.endpoint]) { //if connector is not yet initialized, initialize
      connector.connect();
      this.connectors[connector.endpoint] = connector;
    }

    return this.connectors[connector.endpoint];
  }

}
